import { useContext, useEffect, useRef } from "react"
import { Button, Checkbox, Form, Input, Modal, Select } from "antd"
import { useCostCodes } from "../../../../../domain/costCodes/costCodeQueries"
import { useDivisions } from "../../../../../domain/divisions/divisionsQueries"
import { Workarea } from "../../../../../domain/job"
import { useDuplicateWorkareaMutation } from "../../../../../domain/workareas/workareaQueries"
import JobPlanContext from "../../JobPlanContext"

export type DuplicateForm = {
  name: string
  costCodeId: number
  divisionId: number
  copyItems: boolean
}

type Props = {
  isOpen: boolean
  onCancel: () => void
  workarea: Workarea | undefined
}

const DuplicateWorkareaModal = ({ isOpen, onCancel, workarea }: Props) => {
  const { currentSelection, selectWorkarea} = useContext(JobPlanContext)
  const [form] = Form.useForm<DuplicateForm>()
  const nameRef = useRef<any>()

  const costCodesQuery = useCostCodes()
  const costCodeOptions = costCodesQuery.data?.map(x => ({ label: x.name, value: x.id })) ?? []

  const divisionsQuery = useDivisions()
  const divisionOptions = divisionsQuery.data?.map(x => ({ label: x.name, value: x.id })) ?? []

  const duplicateWorkareaMutation = useDuplicateWorkareaMutation((workareaId: number) => {
    handleCancel()

    if(currentSelection?.workareaId !== undefined){
      selectWorkarea(workareaId)
    }
  })

  const handleDelete = () => {
    if (workarea?.id) {
      const formValues = form.getFieldsValue()
      duplicateWorkareaMutation.mutate({ workareaId: workarea.id, jobId: workarea.jobId, form: formValues })
    }
  }

  const handleCancel = () => {
    onCancel()
    resetForm()
  }

  const resetForm = () => {
    form.setFieldsValue({
      name: workarea?.name ?? '',
      costCodeId: workarea?.costCodeId ?? 0,
      divisionId: workarea?.divisionId ?? 0,
      copyItems: true
    })
  }

  /* eslint-disable-next-line */
  useEffect(resetForm, [workarea?.id])

  return <Modal
    open={isOpen}
    onCancel={handleCancel}
    title="Duplicate Workarea"
    forceRender
    footer={[
      <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
      <Button key="submit" type="primary" onClick={handleDelete}>Duplicate</Button>
    ]}
  >
    <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} style={{ marginTop: 24 }}>
      <Form.Item name="name" label="Workarea Name">
        <Input ref={nameRef} />
      </Form.Item>
      <Form.Item name="costCodeId" label="Cost Code">
        <Select options={costCodeOptions} />
      </Form.Item>
      <Form.Item name="divisionId" label="Division">
        <Select options={divisionOptions} />
      </Form.Item>
      <Form.Item name="copyItems" valuePropName="checked" wrapperCol={{ offset: 6, span: 16 }}>
        <Checkbox> Copy all items from this work area</Checkbox>
      </Form.Item>
    </Form>
  </Modal>
}

export default DuplicateWorkareaModal